import { memo } from 'react';
import cn from 'classnames';
import { Grid, Accordion, AccordionGroup } from 'ht-styleguide';
import styles from './skuitemfaq.module.scss';

/* Types */
import { SkuFaq } from 'types/sku.types';
import LazyComponent from '@components/LazyComponent';

type SkuItemFaqProps = {
  items: SkuFaq[];
  className?: string;
};

const SkuItemFaq = ({ className, items }: SkuItemFaqProps) => {
  if (!items || items?.length === 0) return null;

  return (
    <LazyComponent minHeight={items.length ? `${(items.length || 1) * 40 + 150}px` : '0'}>
      <div className={styles.faq} data-testid="sku-item-faq">
        <Grid.FullWidth>
          <Grid.Row>
            <Grid.Column>
              <h3 className={cn('h3 text-align-center', styles.title)}>Frequently Asked Questions</h3>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column sm={4} md={8} lg={6} lgOffset={3}>
              <AccordionGroup className={styles.list}>
                {items.map(f => (
                  <Accordion key={f.id} title={f.questionText} className={styles.item}>
                    <div className={cn('p1', 'accordion_group__item')} dangerouslySetInnerHTML={{ __html: f.answerText }} />
                  </Accordion>
                ))}
              </AccordionGroup>
            </Grid.Column>
          </Grid.Row>
        </Grid.FullWidth>
        <style jsx>{`
          .accordion_group__item {
          }
        `}</style>
      </div>
    </LazyComponent>
  );
};
export default memo(SkuItemFaq);
